import styled from "styled-components";
import FormSelect from "../FormSelect";

const StyledSelectWithLabel = styled.div`
    padding-top: 15px;

    select {
        margin-top: 5px;
    }
`;

const LabelRegular = styled.div`
    font-size: 12px;
    font-weight: 600;
`;

function FormSelectWithLabel(props) {

    const {label, labelStyle, selectStyle, ...restProps} = props;

    return (
        <StyledSelectWithLabel style={selectStyle}>
            {label && <LabelRegular style={labelStyle}>{label}</LabelRegular>}
            <FormSelect {...restProps} />
        </StyledSelectWithLabel>
    )
}

export default FormSelectWithLabel;